<template>
  <div class="setting_modal">
    <div class="setting_modal_box">
      <div class="setting_modal_box_body">
        <div class="setting_modal_box_close" @click="$emit('close')">
          <!-- クリックでモーダルが閉じるように実装をお願いいたします。 -->
          <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
            <g fill="#AAA" fill-rule="evenodd">
              <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z" />
              <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z" />
            </g>
          </svg>
        </div>
        <p class="setting_modal_box_text">
          {{ screenLabelsProperties.CONFIRM_DELETE_ITEM_MESSAGE }}
        </p>
      </div>
      <div class="setting_modal_box_actions">
        <button class="setting_btn_outline" @click="$emit('close')">
          {{ screenLabelsProperties.CLOSE_MODAL }}
        </button>
        <button class="setting_btn_primary" @click="$emit('delete')">
          {{ screenLabelsProperties.CONFIRM_DELETE_BUTTON }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import screenLabelsProperties from "../../../../properties/entry_screen/screen_tab/screen-labels.json";

export default {
  name: "ConfirmDeleteItemModal",
  data() {
    return {
      screenLabelsProperties: screenLabelsProperties,
    };
  },
};
</script>
<style scoped>
.setting_modal_box {
  height: unset !important;
}
</style>